// extracted by mini-css-extract-plugin
export default {"signPage":"sign-page_signPage__ghVdX","draw":"sign-page_draw__HfO84","error":"sign-page_error__TWL11"};